import React, { useContext, useEffect, useState } from "react";
import ProductoCarrito from "../components/Carrito/ProductoCarrito";
import { CarritoContext } from "../context/CarritoContext";
import Swal from "sweetalert2";
import clienteAxios from "../helpers/axios.helper";
import { useDolar } from "../context/ValorDolarContext";
import { useNavigate } from "react-router-dom";

const Carrito = () => {
  const { productosCarrito, eliminarProductoDelCarrito, modificarCantidadProducto } = useContext(CarritoContext);
  const [productos, setProductos] = useState(productosCarrito);
  const [nombre, setNombre] = useState("");
  const [email, setEmail] = useState("");
  const [codigoArea, setCodigoArea] = useState("");
  const [telefono, setTelefono] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [precioEnvio, setPrecioEnvio] = useState("A cargo del comprador");
  const { valorDolar } = useDolar(); // Obtiene el valor del dólar desde el contexto
  const navigate = useNavigate();

  // Función para calcular el total por producto
  const calcularTotalPorProducto = () => {
    return productosCarrito.reduce((total, producto) => {
      let precioFinal;
  
      if (producto.preciopeso) {
        precioFinal = producto.preciopeso / valorDolar // Precio en dólares
        
      } else {
        // Si no es un servicio, usar las propiedades normales de precio
        precioFinal = producto.mostrar_precio_dolar
          ? producto.precioventadolar * producto.cantidad // Precio en dólares
          : producto.precioventapeso * producto.cantidad / valorDolar; // Precio en pesos
      }
      let precio = Math.floor(total + precioFinal);
      if (precio <= 0) {
        precio = 1;
      }
      return  precio;
    }, 0);
  };
  

  // Función para calcular la cantidad total de productos
  const calcularCantidadTotal = () => {
    return productosCarrito.reduce((total, producto) => {
      return total + producto.cantidad;
    }, 0);
  };

  // Función para calcular el total del envío
  const calcularTotalDelEnvio = () => {
    return calcularTotalPorProducto();
  };

  useEffect(() => {
    setProductos(productosCarrito);
  }, [productosCarrito]);

  const handleRedirectProductos = () => {
    navigate(('/productos'), { state: { deCarrito: true } });
  }

  // Función para manejar el envío del pedido
  const handleEnviarPedido = async () => {
    if (productos.length === 0) {
      Swal.fire({
        icon: "error",
        title: "¡Carrito vacío!",
        text: "No puedes enviar un pedido sin productos.",
      });
      return;
    }
  
    if (!nombre || !email || !telefono || !mensaje) {
      Swal.fire({
        icon: "warning",
        title: "¡Campos incompletos!",
        text: "Por favor, completa todos los campos del formulario.",
      });
      return;
    }
  
    // Aquí, en lugar de pasar solo `productos`, pasamos los productos con la cantidad seleccionada.
    const productosConCantidad = productos.map((producto) => ({
      ...producto,  // Mantiene las demás propiedades del producto
      cantidad: producto.cantidad,  // Asegura que la cantidad seleccionada se pase correctamente
    }));
  
    // Mostrar el mensaje de "Enviando..."
    Swal.fire({
      title: "Enviando Pedido...",
      text: "Por favor espera mientras procesamos tu pedido.",
      allowOutsideClick: false, // No permitirá cerrar el modal mientras se envía el pedido
      onBeforeOpen: () => {
        Swal.showLoading();
      }
    });
  
    try {
      // Enviamos los datos en el formato adecuado
      const response = await clienteAxios.post("/email/enviar", {
        type: "carrito", // Aquí puedes usar un tipo como "pedido"
        data: {
          nombre,
          email,
          codigoArea,
          telefono,
          mensaje,
          productos: productosConCantidad,  // Asegura que la cantidad está incluida
          total: calcularTotalDelEnvio(),
          valorDolar:valorDolar
        },
      });
  
      // Manejo de la respuesta
      if (response.status === 200) {
        // Cerrar el mensaje de carga y mostrar éxito
        Swal.fire({
          icon: "success",
          title: "¡Pedido Enviado!",
          text: "Tu pedido se ha enviado correctamente, te contactaremos pronto.",
        });
  
        // Redirigir al inicio (puedes ajustar la ruta si es necesario)
        setTimeout(() => {
          window.location.href = "/"; // O usa history.push("/") si estás usando react-router-dom
        }, 2000); // Redirige después de 2 segundos para que el usuario vea el mensaje de éxito
      } else {
        // Cerrar el mensaje de carga y mostrar error
        Swal.fire({
          icon: "error",
          title: "Error al enviar el pedido",
          text: "Hubo un problema al procesar tu pedido. Intenta nuevamente.",
        });
      }
    } catch (error) {
      console.error(error);
      // Cerrar el mensaje de carga y mostrar error
      Swal.fire({
        icon: "error",
        title: "Error al enviar el pedido",
        text: "Hubo un error al intentar enviar tu pedido. Intenta nuevamente.",
      });
    }
  };

  return (
    <div className="p-4 w-full min-h-screen bg-GrisClaro flex flex-col items-center">
      <div className="flex flex-col md:flex-row justify-center bg-Blanco mt-7 p-5 w-10/12 border border-Negro rounded-xl shadow-carritoshadow">
        <div className="w-full md:w-2/5 rounded px-8 pb-2 mb-5 md:mb-0">
          <h2 className="text-xl font-bold text-center mb-3">Resumen del Pedido</h2>
          <hr className="mb-3" />
          <div className="flex justify-between mb-2">
            <label className="text-xs font-bold text-GrisOscuro">{`Productos (${calcularCantidadTotal()})`}</label>
            <label className="text-xs font-bold text-Verde">US${calcularTotalPorProducto()}</label>
          </div>
          <div className="flex justify-between mb-2">
            <label className="text-xs font-bold text-GrisOscuro">Envío</label>
            <label className="text-xs font-bold text-Amarillo">{precioEnvio}</label>
          </div>
          <hr className="my-3" />
          <div className="flex justify-between text-base font-semibold">
            <label className="text-xs font-bold text-Negro">Total</label>
            <label className="text-xs font-bold text-Verde">US${calcularTotalDelEnvio()}</label>
          </div>
        </div>
  
        {/* Línea separadora: vertical en pantallas grandes, horizontal en pantallas pequeñas */}
        <div className="border-l-2 border-gray-300 mx-3 md:block hidden"></div> {/* Vertical en pantallas grandes */}
        <div className="border-t-2 border-gray-300 mt-3 md:hidden w-full"></div> {/* Horizontal en pantallas pequeñas */}
  
        <div className="w-full pt-4 md:w-3/5 rounded px-8 pb-2">
          <div className="flex gap-2 mb-3">
            <div className="w-1/2">
              <label htmlFor="name" className="block text-sm btw:text-lg font-bold">Nombre</label>
              <input
                type="text"
                id="name"
                className="w-full border border-Negro p-2 rounded rounded-lg"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
              />
            </div>
            <div className="w-1/2">
              <label htmlFor="email" className="block text-sm btw:text-lg font-bold">Email</label>
              <input
                type="email"
                id="email"
                className="w-full border border-Negro p-2 rounded rounded-lg"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>
          <div className="flex gap-3 mb-3">
            <div className="w-1/4">
              <label htmlFor="area-code" className="block text-sm btw:text-lg font-bold">Área</label>
              <input
                type="text"
                id="area-code"
                className="w-full border border-Negro p-2 rounded rounded-lg"
                value={codigoArea}
                onChange={(e) => setCodigoArea(e.target.value)}
              />
            </div>
            <div className="w-3/4">
              <label htmlFor="phone" className="block text-sm btw:text-lg font-bold">Teléfono</label>
              <input
                type="text"
                id="phone"
                className="w-full border border-Negro p-2 rounded rounded-lg"
                value={telefono}
                onChange={(e) => setTelefono(e.target.value)}
              />
            </div>
          </div>
          <div className="mb-3">
            <label htmlFor="message" className="block text-sm btw:text-lg font-bold ">Mensaje</label>
            <textarea
              id="message"
              rows="3"
              className="w-full max-h-32 h-32 border border-Negro p-2 rounded rounded-lg"
              placeholder="Agrega un mensaje..."
              value={mensaje}
              onChange={(e) => setMensaje(e.target.value)}
            />
          </div>
        </div>
      </div>
  
      <div className="flex flex-col w-10/12 mt-10 items-center bg-Blanco p-5 rounded-xl max-h-96 border border-Negro shadow-carritoshadow">
        {productos && productos.length > 0 ? (
          <div className="flex flex-col w-full h-80 items-center bg-Blanco overflow-y-auto space-y-4">
            {productos.map((producto) => (
              <div key={producto.id} className="flex flex-col items-center">
                <ProductoCarrito 
                  producto={producto} 
                  modificarCantidadProducto={modificarCantidadProducto}
                  eliminarProducto={eliminarProductoDelCarrito}
                />
                <hr className="my-4 w-10/12 border-t-2 border-GrisOscuro" />
              </div>
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center h-full space-y-4">
            <h1 className="text-2xl font-bold text-Negro">No hay productos en el carrito</h1>
            <p className="text-GrisOscuro">Agrega algunos productos para continuar con tu pedido.</p>
          </div>
        )}
        <div className="w-full p-4">
          {
            productos.length > 0 ? 
              (<button
                className="w-full h-14 text-Blanco p-2 text-sm btw:text-xl bg-Verde border border-Negro py-2 font-bold rounded-lg"
                onClick={handleEnviarPedido}
              >
                {`Enviar Pedido (US$ ${calcularTotalDelEnvio()} + Costo de Envío)`}
              </button>)
              :
              (<button
                className="w-full h-14 text-Blanco p-2 text-sm btw:text-xl bg-Verde border border-Negro py-2 font-bold rounded-lg"
                onClick={handleRedirectProductos}
              >
                {'Buscar Productos'}
              </button>)
          }
        </div>
      </div>
    </div>
  );
  
  
};

export default Carrito;
